import { isRequired } from 'evcharging/app/validation/validators';
import { JOIN_CONFIRMATION_ENDPOINT } from 'evcharging/app/server/endpoints';
import { httpClient } from 'evcharging/app/client/index';

const validators = {
  phone: [isRequired],
};

const sendPhoneConfirmation = (payload: Record<string, string>) =>
  httpClient()
    .setBody(payload)
    .setValidators(validators)
    .post(JOIN_CONFIRMATION_ENDPOINT);

export default sendPhoneConfirmation;
